import ReactMapGl, { Layer, Marker, Source } from "react-map-gl";
import { useState } from "react";
import IconTint from "react-icon-tint";
import { Button, Tooltip } from "@mui/material";
import CropFreeIcon from "@mui/icons-material/CropFree";
import { handleBgColorMarker } from "providers/StylingFunc";
import { useCtx } from "context/SessionDataContext";
import { MapTools } from "./MapTools";

export default function MapGl({
  viewport,
  setViewport,
  polygonFromCaseLocation,
  workOrder,
  networkCoords,
  networkImages,
  showBigMap,
  show,
  openImageModal,
}) {
  const [alignment, setAlignment] = useState(
    "mapbox://styles/mapbox/satellite-streets-v12"
  );
  const [showFieldImg, setShowFieldImg] = useState(true);
  const { appConfig } = useCtx();

  const handleChange = (name) => {
    setAlignment(name);
  };
  return (
    <div>
      {
        <ReactMapGl
          {...viewport}
          mapboxAccessToken={appConfig["env-vars"].mapbox}
          onMove={(newViewport: any) => {
            setViewport(newViewport.viewState);
          }}
          mapStyle={alignment}
          style={{
            margin: "auto",
            width: "100%",
            maxWidth: "100%",
            height: show ? "100%" : "450px",
          }}
        >
          <div className="mapViewBtn">
            {" "}
            <button
              type="button"
              className={
                alignment === "mapbox://styles/mapbox/satellite-streets-v12"
                  ? "btn activeMap"
                  : "btn"
              }
              onClick={() =>
                handleChange("mapbox://styles/mapbox/satellite-streets-v12")
              }
            >
              Flygfoto
            </button>
            <button
              type="button"
              className={
                alignment === "mapbox://styles/mapbox/streets-v12"
                  ? "btn activeMap"
                  : "btn"
              }
              onClick={() => handleChange("mapbox://styles/mapbox/streets-v12")}
            >
              Karta
            </button>
          </div>

          {!show && (
            <Button onClick={() => showBigMap(!show)} className="zoomMapIcon">
              <CropFreeIcon />
            </Button>
          )}

          <div key={polygonFromCaseLocation}>
            {networkCoords &&
              Object.keys(networkCoords).map((key) => {
                if (networkImages[key] && networkCoords[key]) {
                  return (
                    <div key={networkImages[key]}>
                      <Source
                        url={networkImages[key]}
                        coordinates={networkCoords[key]}
                        type={"image"}
                        id={networkImages[key]}
                      >
                        <Layer
                          type={"raster"}
                          paint={{}}
                          id={networkImages[key]}
                          key={networkCoords[key]}
                        />
                      </Source>
                    </div>
                  );
                } else {
                  return <div key={key} />;
                }
              })}
          </div>
          {polygonFromCaseLocation && (
            <div>
              <Source id="data" type="geojson" data={polygonFromCaseLocation} />
              <Layer
                id={"new"}
                type="fill"
                paint={{
                  "fill-color": "red",
                  "fill-opacity": 0.3,
                }}
                source={"data"}
              />
            </div>
          )}

          {workOrder?.Center?.WGS84.map((data) => {
            return (
              <Marker
                key={"Marker" + data[0]}
                longitude={data[1]}
                latitude={data[0]}
                anchor="center"
              >
                <div>
                  <IconTint
                    src="https://img.icons8.com/material-sharp/48/000000/give-way--v1.png"
                    color={handleBgColorMarker(workOrder?.Status)}
                  />
                </div>
              </Marker>
            );
          })}
          {workOrder?.ImageData?.map((img, i) => {
            if (
              showFieldImg &&
              img?.longitude &&
              img?.latitude &&
              Math.floor(viewport?.zoom) > 10
            ) {
              return (
                <button
                  onClick={() => openImageModal(i)}
                  key={img.longitude + img.latitude}
                >
                  <Marker
                    key={img.longitude + img.latitude}
                    longitude={img.longitude}
                    latitude={img.latitude}
                    anchor="center"
                    style={{ cursor: "pointer" }}
                  >
                    <Tooltip
                      placement="top"
                      arrow
                      enterDelay={250}
                      title={`Position för bild ${img.name}`}
                    >
                      <div>
                        <IconTint
                          maxHeight={75}
                          maxWidth={75}
                          src={img.url}
                          color={"transparent"}
                        />
                      </div>
                    </Tooltip>
                  </Marker>
                </button>
              );
            }
            return null;
          })}
          {workOrder.ImageData?.find(
            (img) => img?.longitude && img?.latitude
          ) && (
            <MapTools
              isBigMap={show}
              showFieldImg={showFieldImg}
              setShowFieldImg={setShowFieldImg}
            />
          )}
        </ReactMapGl>
      }
    </div>
  );
}
